module.exports = __webpack_public_path__ + "assets/006cadd5abc182689e63b02480cffb50.svg";